// Piezas comunes de los bloques de un sitio público.

import type { ReactNode } from "react";
import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

/** Campo de formulario grande (16 px: el celular no hace zoom al enfocarlo). */
export const siteFieldClass =
  "block w-full rounded-md border border-input bg-card px-3 py-2.5 text-base text-foreground shadow-xs outline-none transition-colors placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-60 aria-invalid:border-destructive";

export function BlockTitle({ children, className }: { children: ReactNode; className?: string }) {
  return <h2 className={cn("text-base font-semibold text-foreground", className)}>{children}</h2>;
}

export function BlockEmpty({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-2 rounded-lg border border-dashed bg-card/60 px-4 py-8 text-center text-sm text-muted-foreground">
      <Inbox className="size-5 opacity-60" aria-hidden />
      <p>{children}</p>
    </div>
  );
}
